import angular from 'angular';

/**
 * @memberOf cms.input.object.select
 * @property {object}      bindings.errors     Form errors object
 * @property {object|text} bindings.model      Input value reference
 * @property {string}      bindings.label      Input label and placeholder
 * @property {string}      bindings.helper     Helper message for input
 * @property {array}       bindings.options    Objects array  [{value:'val', label: 'Val}]
 * @property {string}      bindings.labelSize  Label column size (1-12)
 * @property {string}      bindings.inputSize  Input column size (1-12)
 * @property {string}      bindings.aclShow    ACL config - show input
 * @property {string}      bindings.aclDisable ACL config - disable input
 *
 * @todo More flexible data operations in ui-select-choices
 */
let cmsInputObjectSelect = {
    bindings: {
        errors: '<',
        model: '=',
        label: '@',
        helper: '@',
        options: '<',
        aclShow: '<?',
        aclDisable: '<?',
        labelSize: '@',
        inputSize: '@',
        validator: '<'

    },
    template: require('./objectSelect.html'),
    controller: function ($scope) {
        this.$onInit = () => {
            $scope.validatorErrors = this.validator;
            if(angular.isFunction(this.options)){
                this.options = this.options();
            }
        };

        this.$onChanges = () => {
            $scope.validatorErrors = this.validator;
        }


    }
};

/**
 * Select control using ui-select
 * @namespace cms.input.select
 * @see https://angular-ui.github.io/ui-select
 */
export default angular.module('cms.input.object.select', []).component('cmsInputObjectSelect', cmsInputObjectSelect).name;




// WEBPACK FOOTER //
// ./src/cmsCore/Controls/ObjectSelectControl/CmsInputObjectSelect.js